/**
 * Curated per-role starter prompts for the empty-state query pills.
 *
 * These are intentional, owned product copy — not throwaway seed data. Each
 * role gets a small set of coherent, answerable questions that show what the
 * assistant is for. Keep them static and role-driven; dynamic or personalized
 * suggestions (e.g. derived from a user's own fleet) are a deferred follow-up.
 */
import type { Role } from '../lib/auth';

// Network-ops prompts for internal staff/admins (aligned to the helium-network
// data skills). Shared by the `admin` and `internal` roles.
const INTERNAL_PROMPTS = [
  "What's the AT&T rejection rate over the last 7 days?",
  'How many access points carried traffic last week?',
  'Daily active users across all carriers this month',
  'Top HMH builders by deployments',
];

/** Suggested empty-state prompts per role. */
export const ROLE_PROMPTS: Record<Role, string[]> = {
  admin: INTERNAL_PROMPTS,
  internal: INTERNAL_PROMPTS,
  carrier: [
    'Where should we target expansion in Austin?',
    'Network health & reliability in Brooklyn',
    "Review this week's onboarded Hotspots",
    'Show the latest WiFi metrics report',
  ],
  deployer: [
    'Show traffic & AP usage for my Helium+ site',
    'How much data did I offload last week?',
    'What are my access points earning?',
    'Which AP has the most clients?',
  ],
  general: [
    'What are the earnings for Raspy Cobalt Cobra over the past 90 days?',
    'How is my fleet doing?',
    'Compare my Hotspots',
    'Which Hotspot needs attention?',
  ],
};

export function promptsForRole(role: Role): string[] {
  return ROLE_PROMPTS[role] ?? ROLE_PROMPTS.general;
}
